import { reactive } from 'vue';

const logs = reactive<{
    store: Array<unknown>;
    eventbus: Array<unknown>;
}>({
    store: [],
    eventbus: [],
});

const log = (type: 'store' | 'eventbus', data: unknown) => {
    logs[type].push({
        type,
        ts: new Date().toISOString(),
        data,
    });
    if (logs[type].length > 100) {
        logs[type].shift();
    }
};

export const useLogs = () => ({
    logs,
    log,
});
